import { render, staticRenderFns } from "./ul-block.vue?vue&type=template&id=9b4bd874&scoped=true&"
import script from "./ul-block.vue?vue&type=script&lang=js&"
export * from "./ul-block.vue?vue&type=script&lang=js&"
import style0 from "./ul-block.vue?vue&type=style&index=0&id=9b4bd874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4bd874",
  null
  
)

export default component.exports